//
//
//
//
//
//
//

import Drip from 'drip';
export default {
  data: function data() {
    return {
      text: ''
    };
  },
  props: {
    yellowStripInfo: {
      type: Object
    }
  },
  mounted: function mounted() {},
  methods: {
    goMFUrl: function goMFUrl(url) {
      var _ref = this.yellowStripInfo || {},
        jumpUrl = _ref.jumpUrl;
      if (!jumpUrl) return;
      this.go(jumpUrl, {
        _blank: true
      });
    }
  }
};